let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fhJbz")).then(() => parcelRequire('eWfwO'));